module.exports = __webpack_public_path__ + "static/parade-2020-house60-71de891f40e0d438a6649daf21aa2ed4.jpg";